// extracted by mini-css-extract-plugin
module.exports = {"panel":"Panel_panel__2GY6E","panel-header":"Panel_panel-header__2f979","panel-body":"Panel_panel-body__3B_hs"};